import Vue from 'vue'
import * as types from '../event_types'
import * as restlet from '../actions/rest'



const state = {
    members: [],
    searchTerm: ''
  }
  const mutations = {
    setMembers(s, members){
      Vue.set(s, 'members', members)
    },
    setSearchTerm(s, term) {
      Vue.set(s, 'searchTerm', term)
    },
    addMember(s, member) {
      Vue.set(s, 'members', s.members.concat(member))
    }
  }
  const actions = {
    fetchMembers({ commit }){
      restlet.getMembers().then(function(response){
        commit(types.SET_MEMBERS, response.data.data)
      })
    },
    searchMembers({ commit }, term){
      commit(types.SET_SEARCH_TERM, term)
    },
    saveMember({ commit }, member){
      restlet.createMember(member).then(function(response){
        commit(types.ADD_MEMBER, response.data.data)
      })
    }
  }
  const getters = {
    filteredMembers: (s) => {
      if (s.searchTerm) {
        return s.members.filter(m => `${m.first_name} ${m.last_name}`.toLowerCase().includes(s.searchTerm.toString().toLowerCase()))
      }else {
        return s.members
      }
    }
  }

export default {
  state,
  getters,
  actions,
  mutations
}
